import { render, staticRenderFns } from "./component-list.vue?vue&type=template&id=05369b62"
import script from "./component-list.vue?vue&type=script&lang=js"
export * from "./component-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports